module.exports = __webpack_public_path__ + "img/dlssr-currency-guide-1.652c9e1b.png";